<div class="menu_topbar_first-level">
  @if(menuService.newVersion){
    <span class="has-new-notifications"></span>
  }
  <i (click)="openMenu()" class="icon icon-notifications"></i>
</div>
@if (isOpen && menuService.newVersion) {
  <div class="menu_topbar-content">
    <div class="menu_topbar_second-level">
      <ul>
        <li>
          <span (click)="reload()">
            <i class="icon icon-reload"></i>
            <span>Actualiser la page</span>
          </span>
        </li>
      </ul>
    </div>
  </div>
}
